<template>
    <div>
        <Header />
        <PageTitle />
        <CheckoutContent />
        <Footer />
    </div>
</template>

<script>
import Header from '../Layout/Header'
import PageTitle from '../Checkout/PageTitle'
import CheckoutContent from '../Checkout/CheckoutContent'
import Footer from '../Layout/Footer'

export default {
    name: 'CheckoutPage',
    components: {
        Header,
        PageTitle,
        CheckoutContent,
        Footer,
    }
}
</script>